import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiClock, FiEye, FiShield, FiDollarSign, FiHeart} = FiIcons;

const BenefitsSection = () => {
  const benefits = [
    {
      icon: FiClock,
      title: 'Zeit sparen',
      description: 'Routineaufgaben automatisieren sich. Du musst weniger tippen, sortieren und nachtragen.'
    },
    {
      icon: FiEye,
      title: 'Überblick behalten',
      description: 'Alle Belege, Rechnungen und Zahlungen an einem Ort – klar nachvollziehbar und jederzeit abrufbar.'
    },
    {
      icon: FiShield,
      title: 'Rechtssicher arbeiten',
      description: 'GoBD-konforme Ablage und korrekte Prozesse, ohne Unsicherheit und ohne Rätselraten.'
    },
    {
      icon: FiDollarSign,
      title: 'Kosten senken',
      description: 'Weniger doppelte Arbeit, weniger Fehler, weniger Steuerberateraufwand.'
    },
    {
      icon: FiHeart,
      title: 'Mehr Ruhe im Alltag',
      description: 'Du weißt, dass alles in Ordnung ist. Das nimmt Druck raus und schafft Raum für das, was wirklich wichtig ist.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            So profitierst du von digitaler Buchhaltung
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Wenn Abläufe klar und einfach sind, entsteht Ruhe. 
            Mit einer digitalen Buchhaltung wird vieles leichter, weil du weniger manuell erledigen musst
            und jederzeit weißt, wo du stehst.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 text-center"
            >
              <div className="mb-4 flex justify-center">
                <SafeIcon icon={benefit.icon} className="text-[#E30613] text-4xl" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-600 text-sm">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;